import React, { useState } from 'react';

const steps = [
    {
        title: 'Step 1 – Consultation',
        content: 'Begin your journey with a free initial consultation where we discuss your space, style preferences, and budget. Our expert designers will assess your requirements and suggest the best design direction for your home.',
        open: true,
    },
    {
        title: 'Step 2 – Design Planning',
        content: 'Our team creates detailed 3D design visualizations and floor plans, so you can see exactly how your space will look before a single nail is hammered.',
        open: false,
    },
    {
        title: 'Step 3 –Material specification',
        content: 'Choose from our curated catalog of premium materials — from MDF, plywood, and HDHMR boards to laminates, acrylic finishes, and lacquered glass — guided by our material experts.',
        open: false,
    },
    {
        title: 'Step 4 – Execution',
        content: 'Our skilled craftsmen and project managers bring the design to life with precision. We provide MEP drawings and monitor every stage of execution for quality assurance.',
        open: false,
    },
    {
        title: 'Step 5 – Final Handover',
        content: 'Complete the journey with a comprehensive final walkthrough, our 10-year warranty certificate, and the official handover of your beautifully transformed home — on time, every time.',
        open: false,
    },
];

export default function HowToWork() {
    const [openStep, setOpenStep] = useState(0);

    return (
        <section className="section-pad relative overflow-hidden" id="how-to-work">
            {/* Dark gradient bg */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#0A1128] via-[#1C2541] to-[#001524]" />
            <div className="relative max-w-7xl mx-auto px-4">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    {/* Left: Image */}
                    <div className="relative">
                        <div className="rounded-3xl overflow-hidden shadow-2xl shadow-black/50">
                            <img
                                src="https://images.unsplash.com/photo-1600607688969-a5bfcd646154?w=800&q=80"
                                alt="Bliv Design Studio design team"
                                className="w-full h-[500px] object-cover"
                            />
                        </div>
                        {/* Floating badge */}
                        <div className="absolute -bottom-6 -right-6 bg-[#2E63E8] rounded-2xl p-5 shadow-xl text-center">
                            <div className="text-3xl font-bold text-black">500+</div>
                            <div className="text-black text-xs font-semibold mt-1">Projects Completed</div>
                        </div>
                    </div>

                    {/* Right: Accordion */}
                    <div>
                        <p className="text-[#2E63E8] font-semibold uppercase tracking-widest text-sm mb-3">Our Process</p>
                        <h2 className="text-4xl md:text-5xl font-bold text-white mb-8 leading-tight">
                            How to work<br /><span className="text-[#2E63E8]">with us?</span>
                        </h2>

                        {/* Accordion */}
                        <div className="space-y-3">
                            {steps.map((step, i) => (
                                <div
                                    key={i}
                                    className={`rounded-xl overflow-hidden border transition-all duration-300
                    ${openStep === i ? 'border-[#2E63E8] bg-[#2E63E8]/10' : 'border-gray-700 bg-white/5'}`}
                                >
                                    <button
                                        onClick={() => setOpenStep(openStep === i ? -1 : i)}
                                        className="w-full flex items-center justify-between px-5 py-4 text-left"
                                    >
                                        <span className={`font-semibold text-sm md:text-base ${openStep === i ? 'text-[#2E63E8]' : 'text-white'}`}>
                                            {step.title}
                                        </span>
                                        <span className={`text-2xl font-light flex-shrink-0 ml-4 transition-colors ${openStep === i ? 'text-[#2E63E8]' : 'text-gray-400'}`}>
                                            {openStep === i ? '−' : '+'}
                                        </span>
                                    </button>
                                    <div className={`accordion-content ${openStep === i ? 'open' : ''}`}>
                                        <p className="px-5 pb-4 text-gray-300 text-sm leading-relaxed">
                                            {step.content}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* CTA */}
                        <div className="mt-8">
                            <a
                                href="/contact"
                                className="inline-flex items-center gap-2 bg-[#2E63E8] hover:bg-[#1c3b8b] text-white font-bold px-8 py-4 rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-blue-900/50 hover:-translate-y-1"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                Book Free Design Session
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
